import React from 'react';

interface DiegeticTimerProps {
  remaining: number; // in seconds
  paused?: boolean;
}

const pad = (n: number) => String(n).padStart(2, '0');

const DiegeticTimer: React.FC<DiegeticTimerProps> = ({ remaining, paused = false }) => {
  const minutes = pad(Math.floor(remaining / 60));
  const seconds = pad(remaining % 60);

  return (
    <div className={`th-timer ${paused ? 'is-paused' : ''}`} role="timer">
      {minutes}
      <span className="th-timer-colon">:</span>
      {seconds}
    </div>
  );
};

export default DiegeticTimer;
